// extracted by mini-css-extract-plugin
module.exports = {"SectionCard":"PlaneCard_SectionCard__Vx9UM"};